'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FourZeroFour = function FourZeroFour() {
  return _react2.default.createElement(
    _NavApp2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: 'dummy-page bad-link' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          '404 - Not Found'
        )
      )
    )
  );
};

exports.default = FourZeroFour;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/FourZeroFour.js
// module id = 371
// module chunks = 0